import { useEffect } from 'react';

type User = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  tenant_id: number;
};

type Options = {
  user: User | null;
  loading: boolean;
};

export const useRedirectIfNoUser = ({ user, loading }: Options) => {

  useEffect(() => {
    if (!loading && user === null) {
      window.location.replace('/login?status=need_login');
    }
	}, [user, loading]);
};